var underlineFontHackRegex = /font\((--[^)]+)\)/;
export var defaultReplacers = {
    underlineFontHackSupport: function (key, value) {
        var matches;
        if (key === 'font' && (matches = value.match(underlineFontHackRegex))) {
            return { key: key, value: value + ";text-decoration: \"underline(" + matches[1] + ")\"" };
        }
        return { key: key, value: value };
    }
};
//# sourceMappingURL=defaultReplacers.js.map